import { render } from "./klaviyo-footer.vue?vue&type=template&id=0012fa3e"
import script from "./klaviyo-footer.vue?vue&type=script&lang=js"
export * from "./klaviyo-footer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__